import { Component, OnInit, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { branding } from '../../core/config/branding';
import { BillingPlan, BillingService } from '../../core/services/billing.service';
import { LoggerService } from '../../core/services/logger.service';
import { ButtonComponent } from '../../shared/components/button/button.component';
import { CardComponent } from '../../shared/components/card/card.component';
import { SpinnerComponent } from '../../shared/components/spinner/spinner.component';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';

@Component({
  selector: 'app-pricing',
  standalone: true,
  imports: [ButtonComponent, CardComponent, SpinnerComponent, TranslatePipe],
  templateUrl: './pricing.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './pricing.component.css',
})
export class PricingComponent implements OnInit {
  protected readonly salesEmail = `sales@${branding.baseDomain}`;

  private billingService = inject(BillingService);
  private router = inject(Router);
  private logger = inject(LoggerService).getLogger('pricing');

  state = signal<'loading' | 'loaded' | 'error'>('loading');
  plans = signal<BillingPlan[]>([]);

  ngOnInit(): void {
    this.billingService.getPlans().subscribe({
      next: (response) => {
        this.plans.set(response.plans);
        this.state.set('loaded');
      },
      error: (err) => {
        this.logger.error('Failed to load billing plans:', err);
        this.state.set('error');
      },
    });
  }

  formatPrice(cents: number | null): string {
    if (cents === null) {
      return '';
    }
    if (cents === 0) {
      return '$0';
    }
    return `$${(cents / 100).toFixed(0)}`;
  }

  selectPlan(plan: BillingPlan): void {
    this.router.navigate(['/signup'], { queryParams: { plan: plan.id } });
  }
}
